// core/data/settings-sections.ts — typed seed for the settings sidebar sections.
//
// Faithfully ported from legacy src/scripts/data/settings-sections.js.
// The 11 sections mirror the legacy settingsSections array exactly; 1.27.70
// adds the sidebar groups from the owner's account_settings_v2 concept.

import type { SettingsGroup, SettingsSection } from '@/core/models/settings';

export const seedSettingsSections: SettingsSection[] = [
  { id: 'account',       label: 'Account Settings',    blurb: 'Update your account information and manage your profile.' },
  { id: 'privacy',       label: 'Privacy & Security',  blurb: 'Control who can see and interact with you.', group: 'account' },
  { id: 'notifications', label: 'Notifications',       blurb: 'Choose what you get notified about.', group: 'account' },
  { id: 'appearance',    label: 'Appearance',          blurb: 'Theme, density, and visual preferences.', group: 'account' },
  { id: 'sound',         label: 'Sound & Video',       blurb: 'Playback, autoplay, and audio settings.', group: 'account' },
  { id: 'content',       label: 'Content Preferences', blurb: 'Tune the content you see across TruXSocial.', group: 'data' },
  { id: 'data',          label: 'Data & Storage',      blurb: 'Manage cached data and downloads.', group: 'data' },
  { id: 'connected',     label: 'Connected Accounts',  blurb: 'Link and manage third-party accounts.', group: 'data' },
  { id: 'language',      label: 'Language & Region',   blurb: 'Language, region, and formatting.', group: 'support' },
  { id: 'accessibility', label: 'Accessibility',       blurb: 'Make TruXSocial easier to use.', group: 'support' },
  { id: 'about',         label: 'Update Logs',         blurb: 'Release notes, improvements, and platform updates.', group: 'support' },
];

/** Sidebar group headings, in sentence case (owner style rule: no capitals). */
export const SETTINGS_GROUP_LABELS: Record<SettingsGroup, string> = {
  account: 'Account',
  data: 'Data & connections',
  support: 'Support',
};
